import {
  OrderTemplateDetailResult,
  OrderTemplateListResult,
  OrderTemplatePresignedDownloadResult,
  OrderTemplatePresignedUploadResult,
} from '@/coreInfrastructureModule/axios/generated/orderManage/api';
import {
  OrderTemplateDetailEntity,
  OrderTemplateMappingEntity,
  OrderTemplateMetadataEntity,
  OrderTemplateSummaryEntity,
} from '../domains/entities/orderTemplate';
import { OrderTemplateDownloadUrl, OrderTemplateUploadUrl } from '../domains/valueObjects/presignedUrl';

/**
 * 発注テンプレートAPIレスポンスをドメインへ変換するアダプタ
 */
export class OrderTemplateAdapter {
  /**
   * 一覧レスポンスをエンティティへ変換する
   * @param listResult - OpenAPIの一覧レスポンス
   */
  public static toSummaryEntities(listResult: OrderTemplateListResult): OrderTemplateSummaryEntity[] {
    return listResult.templates.map((template) => ({
      templateId: template.templateId,
      fileOriginalName: template.fileOriginalName,
      storagePath: template.storagePath,
      maxOrdersPerSheet: template.maxOrdersPerSheet,
      defaultSheetName: template.defaultSheetName,
      createdBy: template.createdBy,
      updatedBy: template.updatedBy,
      updatedByName: template.updatedByName,
      createAt: template.createAt,
      updateAt: template.updateAt,
      isTrashed: template.isTrashed,
      isDeleted: template.isDeleted,
    }));
  }

  /**
   * 詳細レスポンスをエンティティへ変換する
   * @param detailResult - OpenAPIの詳細レスポンス
   */
  public static toDetailEntity(detailResult: OrderTemplateDetailResult): OrderTemplateDetailEntity {
    const metadata = detailResult.template.metadata;
    const mappings = detailResult.template.mappings;

    const metadataEntity: OrderTemplateMetadataEntity = {
      templateId: metadata.templateId,
      organizationId: metadata.organizationId,
      fileOriginalName: metadata.fileOriginalName,
      storagePath: metadata.storagePath,
      maxOrdersPerSheet: metadata.maxOrdersPerSheet,
      defaultSheetName: metadata.defaultSheetName,
      createdBy: metadata.createdBy,
      updatedBy: metadata.updatedBy,
      createAt: metadata.createAt,
      updateAt: metadata.updateAt,
      isTrashed: metadata.isTrashed,
      isDeleted: metadata.isDeleted,
    };

    const mappingEntities: OrderTemplateMappingEntity[] = mappings.map((mapping) => ({
      mappingId: mapping.mappingId,
      templateId: mapping.templateId,
      fieldKey: mapping.fieldKey,
      startCell: mapping.startCell,
      createAt: mapping.createAt,
      updateAt: mapping.updateAt,
    }));

    return {
      metadata: metadataEntity,
      mappings: mappingEntities,
    };
  }

  /**
   * アップロード用URLをドメインへ変換する
   * @param uploadResult - OpenAPIのアップロードレスポンス
   */
  public static toUploadUrl(uploadResult: OrderTemplatePresignedUploadResult): OrderTemplateUploadUrl {
    return {
      url: uploadResult.url,
      fields: uploadResult.fields,
      expiresAt: uploadResult.expiresAt,
      s3Key: uploadResult.s3Key,
      templateId: uploadResult.templateId,
    };
  }

  /**
   * ダウンロード用URLをドメインへ変換する
   * @param downloadResult - OpenAPIのダウンロードレスポンス
   */
  public static toDownloadUrl(downloadResult: OrderTemplatePresignedDownloadResult): OrderTemplateDownloadUrl {
    return {
      url: downloadResult.url,
      expiresAt: downloadResult.expiresAt,
      fileName: downloadResult.fileName,
      contentType: downloadResult.contentType,
    };
  }
}
